import React, { MouseEventHandler, ReactNode } from "react";
import styled from "styled-components";

interface IIconButtonProps {
  btnName: string;
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: any;
}

const IconButton = (props: IIconButtonProps) => {
  return (
    <IconButtonSet className={props.className} onClick={props.onClick}>
      {props.children}
      <span className="hidden">{props.btnName}</span>
    </IconButtonSet>
  );
};

// IconButton
const IconButtonSet = styled.button`
  position: relative;
  border: 0;
  padding: 0;
  appearance: none;
  font-size: 16px;
  background: none;
  vertical-align: middle;
  cursor: pointer;
  & + & {
    margin-left: 12px;
  }
`;

export default IconButton;
